module.exports = __webpack_public_path__ + "img/banner-career.fbc3324a.jpg";